/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desktopblockdownload2Inputs */



/**
* | output |
* | --- |
* | "or download Luni Monster for Android from Google Play Store." |
*
* @param {Desktopblockdownload2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const desktopblockdownload2 = /** @type {((inputs?: Desktopblockdownload2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktopblockdownload2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("or download Luni Monster for Android from Google Play Store.")
	if (locale === "es") return /** @type {LocalizedString} */ ("o descarga Luni Monster para Android en Google Play Store.")
	return /** @type {LocalizedString} */ ("или скачай приложение Luni Monster для Android в Google Play Store")
});
export { desktopblockdownload2 as "desktopBlockDownload" }